"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Lightbulb, Target, Video, Pencil, Package } from "lucide-react";
export default function OurProcess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const steps = [{
    id: 1,
    icon: Lightbulb,
    label: "Discover"
  }, {
    id: 2,
    icon: Target,
    label: "Plan"
  }, {
    id: 3,
    icon: Video,
    label: "Shoot"
  }, {
    id: 4,
    icon: Pencil,
    label: "Pencil"
  }, {
    id: 5,
    icon: Package,
    label: "Deliver"
  }];
  return <section id="our-process" ref={ref} className="relative w-full py-24 bg-light-background overflow-hidden">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
          {steps.map((step, i) => {
          const Icon = step.icon;
          const delay = i * 100;
          return <div key={step.id} data-index={i} className={`group flex flex-col items-center justify-center gap-4 transition-all duration-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: isVisible ? `${delay}ms` : "0ms"
          }}>
                <div className="relative flex items-center justify-center w-20 h-20 rounded-full bg-accent/10 transition-transform duration-300 group-hover:scale-[1.08]">
                  <Icon className="w-10 h-10 text-accent-dark" strokeWidth={1.5} />
                </div>

                <span className="relative text-base font-semibold text-foreground-light transition-colors duration-300 group-hover:text-accent-dark">
                  {step.label}
                  <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-accent transition-all duration-300 group-hover:w-full" />
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}